var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var WISHLIST_PAGE_SIZE = 12;

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  pagination: '[wishlist-pagination]'
};

document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) {
    setupGrid(grid);
  }
});

var getWishlistPage = function () {
  var params = new URLSearchParams(window.location.search);
  var page = parseInt(params.get('page'), 10);
  return isNaN(page) || page < 1 ? 1 : page;
};

var renderWishlistPagination = function (totalItems, currentPage) {
  var pagination = document.querySelector(selectors.pagination);
  if (!pagination) return;

  var totalPages = Math.ceil(totalItems / WISHLIST_PAGE_SIZE);
  if (totalPages <= 1) {
    pagination.innerHTML = '';
    pagination.hidden = true;
    return;
  }

  pagination.hidden = false;
  var html = '<ul>';
  var prevPage = currentPage > 1 ? currentPage - 1 : null;
  var nextPage = currentPage < totalPages ? currentPage + 1 : null;

  if (prevPage) {
    html += '<li><a href="?page=' + prevPage + '" aria-label="Previous page"><span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span></a></li>';
  } else {
    html += '<li class="disabled prev" aria-disabled="true"><span class="pagination-link" aria-hidden="true"><span><i class="fas fa-angle-double-left"></i></span></span></li>';
  }

  for (var page = 1; page <= totalPages; page++) {
    if (page === currentPage) {
      html += '<li class="active"><span class="pagination-link" aria-current="page">' + page + '</span></li>';
    } else {
      html += '<li><a href="?page=' + page + '">' + page + '</a></li>';
    }
  }

  if (nextPage) {
    html += '<li class="next"><a href="?page=' + nextPage + '" aria-label="Next page"><span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span></a></li>';
  } else {
    html += '<li class="disabled next" aria-disabled="true"><span class="pagination-link" aria-hidden="true"><span><i class="fas fa-angle-double-right"></i></span></span></li>';
  }

  html += '</ul>';
  pagination.innerHTML = html;
};

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var wishlistExistBtn = document.querySelector('.wishlist-page');
  if (wishlist.length > 0 && wishlistExistBtn) {
    wishlistExistBtn.classList = 'wishlist_exists';
  }

  if (!wishlist.length) {
    grid.innerHTML = '';
    renderWishlistPagination(0, 1);
    return;
  }

  var currentPage = getWishlistPage();
  var totalPages = Math.ceil(wishlist.length / WISHLIST_PAGE_SIZE) || 1;
  if (currentPage > totalPages) currentPage = totalPages;

  var start = (currentPage - 1) * WISHLIST_PAGE_SIZE;
  var pageHandles = wishlist.slice(start, start + WISHLIST_PAGE_SIZE);

  var requests = pageHandles.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });

  Promise.all(requests).then(function (responses) {
    grid.innerHTML = responses.join('');
    var buttons = grid.querySelectorAll(selectors.button) || [];
    if (buttons.length) setupButtons(buttons);
    renderWishlistPagination(wishlist.length, currentPage);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', function () {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER).filter(Boolean);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

$(".action-wishlist").on('click', function(){
  $(this).addClass("loading-wishlist adding-wishlist");
  setTimeout(function () {
    $(".action-wishlist").removeClass("loading-wishlist");
  },1000);
  setTimeout(function () {
    $(".adding-wishlist").removeClass("adding-wishlist");
  },2000);
});
